/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs */

const en_shortcut_keys_name_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Down 1 Line`)
};

const fr_shortcut_keys_name_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descendre d'une ligne`)
};

const de_shortcut_keys_name_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Zeile nach unten gehen`)
};

const it_shortcut_keys_name_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spostati di 1 riga verso il basso`)
};

const ru_shortcut_keys_name_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместитесь на 1 строку вниз`)
};

const es_shortcut_keys_name_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bajar 1 línea`)
};

const zh_cn2_shortcut_keys_name_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下移动一行`)
};

const ja_shortcut_keys_name_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行下に移動`)
};

const hi_shortcut_keys_name_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक पंक्ति नीचे जाएं`)
};

const pt_pt2_shortcut_keys_name_cc_move_down_one_line = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desça uma linha`)
};

/**
* | output |
* | --- |
* | "Move Down 1 Line" |
*
* @param {Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_move_down_one_line = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Move_Down_One_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_cc_move_down_one_line(inputs)
	if (locale === "de") return de_shortcut_keys_name_cc_move_down_one_line(inputs)
	if (locale === "it") return it_shortcut_keys_name_cc_move_down_one_line(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_cc_move_down_one_line(inputs)
	if (locale === "es") return es_shortcut_keys_name_cc_move_down_one_line(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_cc_move_down_one_line(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_cc_move_down_one_line(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_cc_move_down_one_line(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_cc_move_down_one_line(inputs)
	return en_shortcut_keys_name_cc_move_down_one_line(inputs)
});